import { Injectable } from '@angular/core';
import { AuthenticationApiService } from '../../../api/go-service/auth-service/authentication.api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export default class AuthenticationDataService {
  constructor(private authenticationApiService: AuthenticationApiService) {}

  public authenticate(credentials: {
    username: string;
    password: string;
    fcmToken?: string;
    dataKlinikUrl?: string;
    deviceInfo?: string;
  }) {
    return this.authenticationApiService.authenticate(credentials);
  }

  public refreshToken(idLogin: number, refreshToken: string): Observable<{ token: string }> {
    return this.authenticationApiService.refreshToken(idLogin, refreshToken);
  }

  public signOut(refreshToken: string) {
    return this.authenticationApiService.signOut(refreshToken);
  }
}
